import React, { useEffect, useState, useRef } from 'react'
import poster1 from '../../images/poster1.jpg';
import poster2 from '../../images/poster2.jpg';
import poster3 from '../../images/poster3.jpg';


const ImageCarousel = (props) => {
  const images = Array.isArray(props.data) 
    ? props.data.map(item => item.image) 
    : [];
console.log("images",images);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const imgRef = useRef();

  useEffect(() => {
    const interval = setInterval(() => goToNext(), 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const openFullscreen = (img) => {
    setFullscreenImage(img);
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    const zoom = e.deltaY < 0 ? 0.1 : -0.1;
    setScale((prev) => Math.min(Math.max(prev + zoom, 1), 4)); // 1x to 4x zoom
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - start.x,
        y: e.clientY - start.y,
      });
    }
  };

  const handleMouseUp = () => setIsDragging(false);
  const handleMouseLeave = () => setIsDragging(false);

  return (
    <div className="carousel-container">
      <div className="carousel-slide">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex}`}
          onClick={() => openFullscreen(images[currentIndex])}
        />
        <button className="left-arrow" onClick={goToPrevious}>❮</button>
        <button className="right-arrow" onClick={goToNext}>❯</button>
      </div>
      <div className="carousel-dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>

      {fullscreenImage && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          <button className="close-button" onClick={closeFullscreen}>✕</button>

          <img
            ref={imgRef}
            src={fullscreenImage}
            alt="Zoomable"
            className="zoomable-image"
            onWheel={handleWheel}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            onClick={(e) => e.stopPropagation()} // prevent closing on drag
            style={{
              transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`,
              cursor: isDragging ? 'grabbing' : scale > 1 ? 'grab' : 'default',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
